
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from "@sentry/angular";

import "hammerjs"; // Including hammerJS to our app

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: "https://3a82483c503d9bdeebfe4229ef484066@o4509534162386944.ingest.de.sentry.io/4509534164484176",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration()
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    // "localhost", // no need to capture localhost errors
    /^https:\/\/corpers\.ng/,
  ]
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
